import { jsonp } from '../../../base/base';
import { faceImgList } from './utils';
import styles from '../comment/hotList/hotListItem/index.css';

import md5 from 'md5';

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

// 解析表情
const resolveFace = (cmtContent) => {
    let newContent = cmtContent;
    const reg = /\[([^\]]*)\]/gim;
    const matchList = cmtContent.match(reg);
    const faceList0 = faceImgList.map((item) => item.title);
    const faceList1 = faceImgList.map((item) => item.name);

    if (matchList) {
        const len = matchList.length;

        for (let i = 0; i < len; i++) {
            const faceStr = matchList[i].replace('[', '').replace(']', '');
            const m = faceList0.indexOf(faceStr);
            const n = faceList1.indexOf(faceStr);

            const index = m === -1 ? n : m;

            let html = '';

            if (index > -1) {
                html = `<span class="${styles.face} ${styles[faceImgList[index].name]}"></span>`;
            }

            newContent = newContent.replace(matchList[i], html);
        }
    }

    return newContent;
};

// 格式化评论数据
const formatHotListData = (data) => {
    data.forEach((item) => {
        // 解析表情
        const content = item.comment_contents;

        item.contents = resolveFace(content);

        // 根据用户名过滤用户连接
        const uname = item.uname;

        if (uname === '客户端用户' || uname === '手机用户' || uname === '凤凰网友') {
            item.user_url = '';
        }

        // 处理时间
        const plTime = item.comment_date;

        item.year = plTime.substr(0, 4);
        item.date = plTime.substr(5, 2);
        item.time = plTime.substr(8, 8);
    });

    return data;
};

// 获取最热评论数据
const getHotList = async (getUrl, docUrl, sKey, hotLimit) => {
    const data = await jsonp(getUrl, {
        data: {
            orderby: 'uptimes',
            docUrl,
            format: 'js',
            job: 1,
            p: 1,
            pageSize: hotLimit,
            skey: sKey,
        },
        jsonpCallback: `${createJsonpCallbackName('newCommentListCallBack')}`,
        cache: true,
    });

    // 格式化评论数据
    data.comments = formatHotListData(data.comments);

    return data;
};

// 评论推荐投票
const vote = async (cmtVoteUrl, comment_id, docUrl) => {
    const data = await jsonp(cmtVoteUrl, {
        data: {
            cmtId: comment_id,
            job: 'up',
            docUrl,
            format: 'js',
        },
        jsonpCallback: 'recmCallback',
    });

    return data;
};

// 提交评论
const postComment = async (content, config) => {
    const data = await jsonp(config.cmtPostUrl, {
        data: {
            docUrl: config.docUrl,
            docName: config.docTitle,
            speUrl: config.speUrl,
            skey: config.skey,
            format: 'js',
            content,
            permalink: config.pcUrl,
        },
        jsonpCallback: 'postCmt',
        cache: false,
    });

    return data;
};

export { getHotList, vote, postComment };
